import React from 'react';
import { AsyncButton } from '../ui/async-button';
import { cn } from '../../lib/utils';

const MicrosoftLogo = () => (
  <svg className="h-5 w-5 flex-shrink-0" viewBox="0 0 23 23" aria-hidden="true">
    <path fill="#f25022" d="M1 1h10v10H1z" />
    <path fill="#00a4ef" d="M12 1h10v10H12z" />
    <path fill="#7fba00" d="M1 12h10v10H1z" />
    <path fill="#ffb900" d="M12 12h10v10H12z" />
  </svg>
);

export function MicrosoftSignInButton({
  onClick,
  isLoading = false,
  disabled = false,
  className,
}) {
  const isBusy = isLoading;

  return (
    <AsyncButton
      type="button"
      variant="outline"
      onClick={onClick}
      pending={isBusy}
      disabled={disabled || isBusy}
      aria-busy={isBusy || undefined}
      loadingText="Redirecting…"
      className={cn(
        'w-full max-w-none min-h-[44px] h-11 sm:h-12 gap-2 sm:gap-3',
        'bg-white dark:bg-gray-900',
        'border border-gray-300 dark:border-gray-600',
        'text-gray-900 dark:text-white',
        'font-medium text-xs leading-tight sm:text-base sm:leading-normal shadow-sm',
        'whitespace-normal text-center sm:whitespace-nowrap',
        'hover:bg-gray-50 dark:hover:bg-gray-800',
        'hover:border-blue-500/60 dark:hover:border-blue-400/50',
        'hover:shadow-[0_0_20px_-4px_rgba(59,130,246,0.45)]',
        'hover:scale-[1.01] active:scale-[0.99]',
        'motion-reduce:hover:scale-100 motion-reduce:active:scale-100 motion-reduce:hover:shadow-sm',
        'focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:ring-inset',
        'transition-[background-color,border-color,color,transform,opacity] duration-200',
        className
      )}
    >
      <MicrosoftLogo />
      Sign in with Microsoft
    </AsyncButton>
  );
}
